import React from 'react';
import { Monitor, formatSchedule } from '../../../../types/monitoring';
import { formatRelativeTime } from '../../../../utils/dateUtils';

interface MonitorInfoCardProps {
  monitor: Monitor;
  isEnabled: boolean;
}

export const MonitorInfoCard: React.FC<MonitorInfoCardProps> = ({ monitor, isEnabled }) => {
  return (
    <div className="bg-neutral-50 rounded-xl p-4">
      <div className="flex items-center gap-2 mb-3">
        <div className={`w-2.5 h-2.5 rounded-full ${isEnabled ? 'bg-success-500' : 'bg-neutral-400'}`} />
        <span className="text-[13px] font-medium text-neutral-700">{isEnabled ? 'Active' : 'Paused'}</span>
      </div>
      <div className="grid grid-cols-3 gap-3 text-[12px]">
        <div className="flex flex-col">
          <div className="text-neutral-500">Schedule</div>
          <div className="font-medium text-neutral-900">{formatSchedule(monitor)}</div>
        </div>
        <div className="flex flex-col">
          <div className="text-neutral-500">Last run</div>
          <div className="font-medium text-neutral-900">{formatRelativeTime(monitor.last_run_at)}</div>
        </div>
        <div className="flex flex-col">
          <div className="text-neutral-500">Next run</div>
          <div className="font-medium text-neutral-900">{isEnabled ? formatRelativeTime(monitor.next_run_at) : '—'}</div>
        </div>
      </div>
    </div>
  );
};
